// import React from 'react'

export const _infotextClass = {
  text: { type: 'string', title: 'Teksti' },
  visible: {
    type: 'string',
    title: 'Kenelle näkyvissä',
    oneOf: [
      { const: 'admin', title: 'Admin' },
      { const: 'cashier', title: 'Kassa' },
      { const: 'all', title: 'Kaikki' },
    ],
    default: 'admin',
  },
  // status: { type: 'string', title: 'Tila', oneOf: [{ const: 'created', title: 'Luotu' }, { const: 'pendingsignature', title: 'Odottaa allekirjoitusta' }, { const: 'signed', title: 'Allekirjoitettu' }, { const: 'cancelled', title: 'Peruttu' }] },
  start: {
    type: 'string',
    format: 'date',
    title: 'Alkaa',
  },
  end: {
    type: 'string',
    format: 'date',
    title: 'Päättyy',
  }
}

export const _infotextClassDeps = {}

export const _infotextUISchema = {
    text: {
      "ui:widget": "textarea",
      "ui:options": {
        "rows": 5
      }
    },
}
